var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNumberTwo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.375C5.68333 1.375 1.375 5.68333 1.375 11C1.375 16.3167 5.68333 20.625 11 20.625C16.3167 20.625 20.625 16.3167 20.625 11C20.625 5.68333 16.3167 1.375 11 1.375ZM14.8958 16.2433H7.44333V15.235L11.66 11.165C12.0358 10.8075 12.3108 10.4958 12.4942 10.2208C12.6775 9.94583 12.7967 9.69833 12.8608 9.46917C12.925 9.24 12.9617 9.01083 12.9617 8.8C12.9617 8.26833 12.7783 7.84667 12.4025 7.54417C12.0267 7.24167 11.4767 7.08583 10.7617 7.08583C10.2117 7.08583 9.7075 7.1775 9.2675 7.36083C8.8275 7.54417 8.4425 7.82833 8.1125 8.21333L7.10417 7.3425C7.49833 6.83833 8.03 6.45333 8.69917 6.17833C9.36833 5.90333 10.1017 5.775 10.8992 5.775C11.6233 5.775 12.2467 5.89417 12.7783 6.12333C13.31 6.3525 13.7225 6.69167 14.0158 7.1225C14.3092 7.55333 14.4558 8.06667 14.4558 8.6625C14.4558 9.00167 14.41 9.33167 14.3183 9.6525C14.2267 9.9825 14.0617 10.3217 13.8142 10.6883C13.5667 11.055 13.2092 11.4583 12.7508 11.9167L9.58833 14.9692H14.8958V16.2617V16.2433Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNumberTwo);
export default __webpack_public_path__ + "static/media/ic-number-two.faec140cec8f06f81d3007b36eb637ee.svg";
export { ForwardRef as ReactComponent };